//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricUtilities.js";
import "../no/TaggedObject.js";
import "../no/SelectDisplayableObject.js";
import "../no/SelectObject.js";
let d=[[[1,"BoundingCurve",0,"SelectDisplayableObject",0],[0,"BoundingObjectMethod",1,0],[0,"BoundingPlane",1,"Plane",0],[0,"BoundingPoint",1,"Point",0],[0,"BoundingPoint1",1,"Point",0],[0,"BoundingPoint2",1,"Point",0],[0,"BoundingProjectPoint",1,"Point",0],[0,"BoundingVector",1,"Direction",0],[0,"IntersectionReference",1,"Point",0]],[[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.GeometricUtilities.BoundingObjectBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricUtilities.BoundingObjectBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricUtilities.BoundingObjectBuilder.Method = Object.freeze({
    "ExistingCurve" : "ExistingCurve", "ProjectPoint" : "ProjectPoint", "LineBy2Points" : "LineBy2Points", "PointAndVector" : "PointAndVector", "ByPlane" : "ByPlane"});

export default SPLM;